module.exports = __webpack_public_path__ + "img/about-story.160089fc.jpg";